import { Button, FormGroup } from 'react-bootstrap';
import { TRAVELER_TYPE } from '../../../../../constants/commondata';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import CloseIcon from '@icons/material/CloseIcon';
import currencyFormatter from 'currency-formatter';
import Autosuggest from 'react-autosuggest';
import { checkShowWarningOutstandingAmount } from '../../../../../utils/commonFunctions';
import AddNewCustomerModal from './AddNewCustomerModal';
import { debounce } from 'lodash';

export const KEY_BOOKER_CONTACT_VALID = 'bookerContact';

const BookerContact = ({
  data,
  selectedFleet = {},
  customerAutocompleteActions,
  psgInfo,
  customerAutocompleteSlectedHandle: customerAutocompleteSlectedHandleProp,
  clearCustomerData,
  newbookingActions,
  corporateActions,
  handleAddNewCustomerSuccess,
  disabled,
  ValidatorCallback,
  valid,
  isSubmited,
  promo
}) => {
  const isShowWarningOutstanding = checkShowWarningOutstandingAmount(
    data,
    selectedFleet
  );
  const [showModalAddNewCus, setShowModalAddNewCus] = useState(false);
  const isBookingDetail = useMemo(() => !!data?.bookId, []);
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [customerText, setCustomerText] = useState('');


  useEffect(() => {
    setCustomerText('');
  }, [data.traveler_type, showModalAddNewCus]);

  useEffect(() => {
    ValidatorCallback(KEY_BOOKER_CONTACT_VALID, customerText?.length > 0 ? false : true);
  }, [customerText]);

  useEffect(() => {
    return () => {
      setCustomerSuggestions([]);
      ValidatorCallback(KEY_BOOKER_CONTACT_VALID, true);
      setCustomerText('');
    };
  }, [data.traveler_type]);

  const customerAutocompleteSlectedHandle = (event, data) => {
    setCustomerText('')
    if (customerAutocompleteSlectedHandleProp) {
      customerAutocompleteSlectedHandleProp(event, data);
    }
  }

  const debouncedGetSuggestions = useCallback(
    debounce((value, travelerType, corporateId) => {
      return fetchCustomerSuggestions(value, travelerType, corporateId);
    }, 200),
    []
  );

  const fetchCustomerSuggestions = (value, travelerType, corporateId) => {
    const escapedValue = value.trim();
    const travelerTypeText = travelerType == 0 ? 'individual' : 'corporation';
    let searchObject = {
      fleetId: selectedFleet.fleetId,
      txtSearch: escapedValue,
      travelerType: travelerTypeText,
    };

    if (travelerTypeText === 'corporation') {
      searchObject.corporateId = corporateId;
    }

    customerAutocompleteActions
      .customerAutocomplete(searchObject)
      .then((result) => {
        if (result?.res?.list?.length > 0) {
          setCustomerSuggestions(result.res.list);
        } else {
          setCustomerSuggestions([{}]);
        }
      });
  };

  const onSuggestionsFetchRequested = (dataInput) => {
    if (
      dataInput.reason !== 'input-focused' ||
      (dataInput.reason === 'input-focused' && dataInput.value)
    ) {
    }
    debouncedGetSuggestions(
      dataInput.value,
      data.traveler_type,
      data.company
    );
  };

  const getSuggestionValue = (suggestion) => {
    return suggestion.phone ? suggestion.phone : '';
  };

  const renderSuggestionUI = (suggestion, { query }) => {
    let { status } = suggestion;
    if (!suggestion.online) {
      status = 'offline';
    } else if (suggestion.status == 'inProgress') {
      status = suggestion.currentJob[0]
        ? suggestion.currentJob[0].status
        : suggestion.status;
    }
    let pickUpTime = data.time;
    const isBookingDetail = !!data.bookId;

    if (isBookingDetail) {
      pickUpTime = data.request.pickUpTime;
    }
    if(_.isEmpty(suggestion)) return null;
    return (
      <div className={`suggestion-content driver-assign`}>
        <div className="info">
          <span className="">
            {`${suggestion.firstName} ${suggestion.lastName} ${
              suggestion.rank === 1 ? ' \u2022 VIP' : ''
            }`}
          </span>
          <span style={{ color: '#98A2B3' }}>{`${
            suggestion.email ? `${suggestion.email}, ` : ''
          } ${suggestion.phone}`}</span>
        </div>
      </div>
    );
  };

  const handleCustomerChange = (e) => {
    setCustomerText(e.target.value || '');
  };

  const renderSuggestionsContainer = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        {children}
        <div className="AddNewCT">
          <Button
            type="button"
            className="btn-header text-add-header btnAddContact"
            onClick={() => setShowModalAddNewCus(true)}
          >
            Add New Contact
          </Button>
        </div>
      </div>
    );
  };

  const renderViewCustomerInfo = () => {
    return psgInfo?.userId ? (
      <>
        <div className="customer-info-container">
          <p className="customer-info-name">
            {`${psgInfo.firstName} ${psgInfo.lastName}`}
            {psgInfo.rank === 1 && (
              <span className="customer-info-vip">VIP</span>
            )}
          </p>
          <span className="customer-info-details">
            {`${psgInfo.phone || ''}\n${psgInfo.email || ''}`}
          </span>
          {!isBookingDetail && !promo?.promoCodeId && (
            <Button
              type="button"
              className="btn-header text-add-header btnAddContact"
              onClick={() => clearCustomerData()}
            >
              <CloseIcon color={'#98A2B3'} />
            </Button>
          )}
        </div>
        {isShowWarningOutstanding && (
          <div className="text-outstanding-warning">
            <Translate
              value="newbooking.Warning_pending_payment"
              fare={currencyFormatter.format(data.outStanding[0].amount, {
                code: data.outStanding[0].currencyISO,
              })}
            />{' '}
          </div>
        )}
      </>
    ) : null;
  };

  return (
    <>
      {isBookingDetail ? (
        renderViewCustomerInfo()
      ) : (
        // create booking
        <>
          {psgInfo?.userId ? (
            renderViewCustomerInfo()
          ) : (
            <>
              <FormGroup
                className={
                  !isSubmited
                    ? null
                    : valid[KEY_BOOKER_CONTACT_VALID] == false
                    ? 'error'
                    : null
                }
              >
                <Autosuggest
                  suggestions={customerSuggestions}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={() => setCustomerSuggestions([])}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestionUI}
                  onSuggestionSelected={customerAutocompleteSlectedHandle}
                  renderSuggestionsContainer={renderSuggestionsContainer}
                  shouldRenderSuggestions={() => true}
                  inputProps={{
                    className: 'form-control form-custom suggestContact',
                    value: customerText,
                    placeholder: I18n.t('newbooking.searchCusPlaceholder'),
                    onChange: handleCustomerChange,
                    disabled: disabled,
                  }}
                />
              </FormGroup>
            </>
          )}
        </>
      )}
      {showModalAddNewCus && (
        <AddNewCustomerModal
          closeModal={() => setShowModalAddNewCus(false)}
          newbookingActions={newbookingActions}
          corporateActions={corporateActions}
          selectedFleet={selectedFleet}
          onAddNewCustomerSucccess={handleAddNewCustomerSuccess}
          traveler_type={data?.traveler_type}
          corporateId={data?.company}
        />
      )}
    </>
  );
};

export default BookerContact;
